import styled from "styled-components"

const StyledChangeMakers = styled.section`
  padding-bottom: 234px;
  .change-makers {
    &__wrapper {
      display: flex;
      max-width: 100%;
    }
    &__gallery {
      flex-basis: 42.5%;
      max-width: 42.5%;
      padding: 110px 0;
      background-color: #fff;
      position: relative;
      z-index: 1;
      .slick-slider,
      .slick-list,
      .slick-track,
      .slick-slide > div {
        height: 100%;
      }
      .slide-inner {
        height: 100%;
      }
      .btn-next {
        position: absolute;
        border: none;
        top: 30px;
        right: 20px;
        padding: 10px;
        svg {
          width: 31px;
          [stroke] {
            transition: 0.2s;
          }
        }
        &:hover {
          svg {
            [stroke] {
              stroke: #00fb6e;
            }
          }
        }
      }
      .gallery-navigation {
        position: absolute;
        bottom: 30px;
        right: 10px;
        display: flex;
        &__item {
          border: none;
          padding: 0;
          width: 155px;
          height: 155px;
          margin: 0 21px;
          position: relative;
          z-index: 2;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
            border-radius: 50%;
            background-color: rgb(255, 255, 255);
            transition: 0.3s;
          }
          .item-background {
            height: 100%;
            overflow: hidden;
            transition: 0.3s;
            border-radius: 50%;
            z-index: 3;
            &__inner {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: rgba(0, 251, 110, 0);
              transition: 0.3s;
              .item-text {
                font-size: 24px;
                line-height: 31px;
                transform: translateY(-15px);
                opacity: 0;
                transition: 0.3s;
              }
            }
          }

          &:hover {
            &::before {
              transform: scale(1.1);
            }
            .item-background {
              &__inner {
                background-color: rgba(0, 251, 110, 0.6);
                .item-text {
                  transform: translateY(0);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
    &__info {
      flex-basis: 57.5%;
      max-width: 57.5%;
      padding: 80px 10% 200px 160px;
      background-color: #000;
      .info-header {
        max-width: 537px;
        margin-bottom: 60px;
        .title {
          color: #e9e9e9;
          text-transform: uppercase;
        }
      }
      .info-slider {
        min-height: 345px;
        .slick-slide.slick-active {
          z-index: 3;
        }
        .change-maker {
          padding-bottom: 20px;
          &__name {
            font-size: 48px;
            line-height: 61px;
            margin-bottom: 33px;
            color: #e9e9e9;
          }
          &__desc {
            margin-bottom: 23px;
            color: #e9e9e9;
          }
          &__link {
            font-size: 24px;
            line-height: 31px;
            text-decoration: underline;
            color: #00fb6e;
            transition: 0.2s;
            display: flex;

            &:not(:last-child) {
              margin: 0 0 15px 0;
            }

            &:hover {
              color: #e9e9e9;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    padding-bottom: 155px;
    .change-makers {
      &__gallery {
        flex-basis: 43%;
        max-width: 43%;
        padding: 76px 0;
        .btn-next {
          position: absolute;
          top: 20px;
          right: 36px;
          svg {
            width: 21px;
          }
        }
        .gallery-navigation {
          bottom: 20px;
          right: 15px;
          &__item {
            width: 110px;
            height: 110px;
            margin: 0 15px;
            .item-background {
              &__inner {
                .item-text {
                  font-size: 16px;
                  line-height: 21px;
                }
              }
            }
          }
        }
      }
      &__info {
        flex-basis: 57%;
        max-width: 57%;
        padding: 50px 10% 125px 110px;
        .info-header {
          margin-bottom: 32px;
        }
        .info-slider {
          min-height: 265px;
          .change-maker {
            padding-bottom: 20px;
            &__name {
              font-size: 24px;
              line-height: 31px;
              margin-bottom: 20px;
            }
            &__desc {
              margin-bottom: 16px;
            }
            &__link {
              font-size: 16px;
              line-height: 21px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    padding-bottom: 100px;
    .change-makers {
      &__info {
        padding: 50px 8% 135px 110px;
        .info-header {
          margin-bottom: 30px;
          .title {
            font-size: 34px;
            line-height: 43px;
          }
        }
        .info-slider {
          min-height: 205px;
          .change-maker {
            padding-bottom: 20px;
            &__name {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 900px) {
    padding-bottom: 0;
    padding-top: 50px;
    .change-makers {
      &__wrapper {
        flex-flow: wrap;
        justify-content: center;
      }
      &__gallery {
        flex-basis: 100%;
        max-width: 100%;
        min-height: 600px;
        padding: 0 8%;
        .btn-next {
          padding: 0;
          top: -50px;
          z-index: 1;
          right: 8%;
        }
        .gallery-navigation {
          position: absolute;
          bottom: 0;
          right: 50%;
          transform: translate(50%, 50%);
          &__item {
            width: 63px;
            height: 63px;
            margin: 0 15px;
            .item-text {
              display: none;
            }
          }
        }
      }
      &__info {
        flex-basis: 100%;
        max-width: 100%;
        padding: 64px 8% 85px;
        .info-header {
          max-width: 337px;
          margin-bottom: 15px;
        }
        .info-slider {
          min-height: initial;
          .change-maker {
            padding-bottom: 12px;
            &__desc {
              line-height: 21px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .change-makers {
      &__gallery {
        min-height: 500px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .change-makers {
      &__gallery {
        min-height: 360px;
        padding: 0 16px;
        .btn-next {
          right: 30px;
        }
      }
      &__info {
        padding: 64px 16px 38px;
        .info-header {
          max-width: 337px;
          margin-bottom: 10px;
        }
        .info-slider {
          margin-bottom: 20px;
          .change-maker {
            padding-bottom: 10px;
            &__name {
              margin-bottom: 12px;
            }
            &__desc {
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 460px) {
    .change-makers {
      &__info {
        .info-header {
          .title {
            font-size: 32px;
          }
        }
      }
    }
  }
`

export default StyledChangeMakers
